module.exports = __webpack_public_path__ + "img/11.af1f243b.jpg";